import * as React from "react";
export class Col extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let cls = "rj-racing-next-races__col" + (this.props.modifier ? ` ${this.props.modifier}` : "");
        return (React.createElement("div", { className: cls }, this.props.children));
    }
}
//# sourceMappingURL=Col.js.map